import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { handleRecipeIncrement_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleRecipeIncrement_V2";
import { handleToggleRecipeSelection_V2 } from "../../../../OrderFlow/components/modules/Recipe/handlers/handleToggleRecipeSelection_V2";
import { useLogging } from "../../../hooks/useLogging/useLogging";
import { useCompanyConfigQuery } from "../../../../SWR/Company/useCompanyConfigQuery";
import { ItemDetailCustomizeText } from "./itemDetailCustomize";
import { useAnalyticsLogging } from "../../../hooks/useAnalyticsLogging/useAnalyticsLogging";
export const AddMealButton = ({ cardControlProps: { isAddDisabled, isSingleSelect, handleToggle, handleQuantityIncrement, recipeHandlerProps_Three: RHP, }, hasAssignments, }) => {
    if (isSingleSelect) {
        // In single-selection mode, we do not respect isAddDisabled.
        // Instead, we follow these rules:
        //
        // - If the recipe has already been added the "Add Meal" button should no longer display, preventing another addition.
        // - If the recipe has not been added the "Add Meal" button should be available for selection.
        if (hasAssignments)
            return null;
    }
    else if (isAddDisabled) {
        // In increment/decrement mode, we respect isAddDisabled.
        // If isAddDisabled is true, the "Add Meal" button should not be displayed.
        return null;
    }
    const { datadogLog } = useLogging(); // UseLoggingReturnType
    const { createKlaviyoEvent, logReactPixel } = useAnalyticsLogging(); // UseAnalyticsLoggingReturnType
    const { companyUsesKlaviyo, keyMap } = useCompanyConfigQuery(); // CompanyContextState
    const reactPixelKey = keyMap.get("FacebookPixelId");
    const shouldUseRecipeHandlers = !!RHP;
    return (_jsx(Button, Object.assign({ variant: "outlined", disabled: !isSingleSelect && isAddDisabled, onClick: () => {
            if (isSingleSelect) {
                if (shouldUseRecipeHandlers) {
                    handleToggleRecipeSelection_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                        createKlaviyoEvent,
                        logReactPixel,
                        datadogLog,
                        reactPixelKey }));
                }
                else if (handleToggle)
                    handleToggle();
            }
            else {
                if (shouldUseRecipeHandlers) {
                    handleRecipeIncrement_V2(Object.assign(Object.assign({}, RHP), { companyUsesKlaviyo,
                        createKlaviyoEvent,
                        logReactPixel,
                        datadogLog,
                        reactPixelKey, createNewAssignment: true, shouldSetAssignmentId: false }));
                }
                if (!!handleQuantityIncrement) {
                    handleQuantityIncrement(true, false);
                }
            }
        } }, { children: ItemDetailCustomizeText.ADD_MEAL })));
};
